import { ModelSagres } from "../model-sagres"

export class LogEvento extends ModelSagres {
    TipoLog: string
    DtLog: Date
    
    tratarDadosDaAPI(): void {
        if (this.DtLog) {
            this.DtLog = new Date(this.DtLog)
        }
        if(this.TipoLog) {
            if(this.TipoLog == 'I')
                this.TipoLog = 'Inserção'
                if(this.TipoLog == 'U')
                this.TipoLog = 'Alteração'
        }
    }
}